import React,{ useEffect,useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const {readData} = useEntityCrud('PersonType/GetAllPersonTypes');
    const [rows,setRows] = useState([]);

    const getData = () => {
        readData().then(({data}) => {
            if(data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
    },[])

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">انواع پرسنل</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد نوع پرسنل جدید</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item,index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length}</p>
                </div> : <div className="alert alert-info"><p>نوع پرسنلی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;